import { Component, ElementRef, inject, OnInit, ViewChild, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {Clipboard} from '@angular/cdk/clipboard';
import { ConfigurationService } from '../../../core/services/configs/configuration';
import { NotificationService } from '../../../core/services/Notification/notification';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '../../../core/services/language/language.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-referals-info',
  imports: [MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIconModule,TranslatePipe,MatTooltipModule],
  templateUrl: './referals-info.html',
  styleUrl: './referals-info.scss'
})
export class ReferalsInfo implements OnInit{
  private clipboard = inject(Clipboard);
  notification = inject(NotificationService);
  language = inject(LanguageService);
  translate = inject(TranslateService);

  readonly dialogRef = inject(MatDialogRef<ReferalsInfo>);
  readonly data = inject(MAT_DIALOG_DATA);

  //private container = viewChild<ElementRef>('myContainer');
  @ViewChild('myContainer') container!: ElementRef;

  configuration = inject(ConfigurationService);
  txtDialog: any;

  ngOnInit(): void {
     this.translate.get(['shared']).subscribe(translations => {
      this.txtDialog = translations['shared'];
    });
    this.dialogRef.disableClose = true;
  }

  eventCopyLink(link: string, block: string){
    this.clipboard.copy(link);
    this.container.nativeElement.querySelector(`#${block}`).innerHTML = this.txtDialog?.txtCopySucc as string;
    // this.notification.setMessage('Ссылка скопирована в буфер обмена');
    // this.notification.display();
  }

  linksCabinet():void{
      const url = `${environment.linkCabinet}${this.language.appLanguage}/`;
      window.open(url, '_blank');
  }

  onNoClick(){
    this.dialogRef.close();
  }

  clickIconClose(event: MouseEvent){
    //if(event.layerX > 390 && event.layerX < 417 && event.layerY > 15 && event.layerY < 40){ 
      this.onNoClick();
    //}
  }
}
